(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cubebuff-email-offer"]) return;
  try {
    
class CubeBuffEmailOffer extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.dialog = this.querySelector('dialog');
    this.launcher = this.querySelector('[data-offer-open]');
    this.backdrop = this.querySelector('[data-offer-backdrop]');
    this.backdrop.addEventListener('click', () => this.close(), options);
    document.addEventListener('keydown', event => {
      if (!this.dialog.open || !this.dialog.contains(document.activeElement)) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); }
      if (event.key !== 'Tab') return;
      const focusable = [...this.dialog.querySelectorAll('button, a[href], input, iframe, [tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement.tagName === 'H2')) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }, options);
    this.key = `cb-offer-${this.dataset.campaign}`;
    this.started = Date.now();
    this.delay = Number(this.dataset.delay) * 1000;
    this.claimed = this.read('claimed') > Date.now();
    this.launcher.hidden = false;
    this.launcher.addEventListener('click', () => this.open(false), options);
    this.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => this.close(), options));
    this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
    this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close(); } }, options);
    this.querySelector('[data-offer-copy]').addEventListener('click', async () => {
      const input = this.querySelector('.cb-email-code input');
      const status = this.querySelector('[data-offer-copy-status]');
      try { await navigator.clipboard.writeText(input.value); status.textContent = status.dataset.copied; }
      catch { input.focus(); input.select(); status.textContent = status.dataset.copyFallback; }
    }, options);
    const resize = () => this.resize();
    window.visualViewport?.addEventListener('resize', resize, options);
    window.addEventListener('resize', resize, options);
    document.addEventListener('visibilitychange', () => this.tryAutomatic(), options);
    window.addEventListener('scroll', () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      if (total > 0 && window.scrollY / total >= .3 && Date.now() - this.started >= 8000) this.tryAutomatic(true);
    }, { ...options, passive: true });
    if (this.querySelector('[data-offer-confirmed]')) {
      this.claimed = true;
      this.write('claimed', Date.now() + 365 * 86400000);
      this.open(false);
      const clean = new URL(window.location.href);
      clean.searchParams.delete('customer_posted');
      if (clean.hash === `#${this.querySelector('form').id}`) clean.hash = '';
      history.replaceState(history.state, '', clean.pathname + clean.search + clean.hash);
    } else if (this.querySelector('[data-offer-error]')) this.open(false);
    else this.timer = window.setInterval(() => this.tryAutomatic(), 1000);
  }
  disconnectedCallback() { this.controller?.abort(); window.clearInterval(this.timer); }
  read(name) { try { return Number(localStorage.getItem(`${this.key}-${name}`)) || 0; } catch { return 0; } }
  write(name, value) { try { localStorage.setItem(`${this.key}-${name}`, String(value)); } catch {} }
  blocked() { return document.hidden || document.documentElement.classList.contains('ps-menu-open') || [...document.querySelectorAll('dialog[open]')].some(dialog => dialog !== this.dialog) || Boolean(document.querySelector('.cb-option-sheet[open],.cb-options-dialog[open]')); }
  tryAutomatic(scrolled = false) {
    if (this.claimed || this.read('dismissed') > Date.now()) { window.clearInterval(this.timer); return; }
    let shown = false;
    try { shown = sessionStorage.getItem(`${this.key}-shown`) === '1'; } catch {}
    if (shown) { window.clearInterval(this.timer); return; }
    if (!scrolled && Date.now() - this.started < this.delay) return;
    if (this.blocked() || ['INPUT','TEXTAREA','SELECT'].includes(document.activeElement?.tagName)) return;
    this.launcher.textContent = this.launcher.dataset.invitation;
    this.launcher.classList.add('cb-email-launcher--invited');
    window.clearInterval(this.timer);
  }
  open(automatic) {
    if (this.blocked() || this.dialog.open) return;
    this.previousFocus = document.activeElement;
    if (this.claimed) { this.querySelector('[data-offer-signup]').hidden = true; this.querySelector('[data-offer-success]').hidden = false; }
    this.resize();
    // Shopify can place its verification iframe outside the form. Keep it above this overlay.
    this.backdrop.hidden = false;
    this.dialog.show();
    this.dialog.querySelector('h2').focus({ preventScroll: true });
    try { sessionStorage.setItem(`${this.key}-shown`, '1'); } catch {}
    window.clearInterval(this.timer);
  }
  close() {
    this.write('dismissed', Date.now() + Number(this.dataset.dismissDays) * 86400000);
    this.dialog.close();
    this.backdrop.hidden = true;
    if (this.previousFocus?.isConnected && this.previousFocus !== document.body) this.previousFocus.focus({ preventScroll: true });
    else this.launcher.focus({ preventScroll: true });
  }
  resize() {
    const viewport = window.visualViewport;
    const height = viewport?.height || window.innerHeight;
    this.dialog.style.setProperty('--cb-offer-height', `${height}px`);
    this.dialog.style.setProperty('--cb-offer-bottom', `${Math.max(12, window.innerHeight - height - (viewport?.offsetTop || 0) + 12)}px`);
  }
}
if (!customElements.get('cubebuff-email-offer')) customElements.define('cubebuff-email-offer', CubeBuffEmailOffer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
